module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-hero",
    attrs: {
      "block": "transparent"
    }
  }, [_c('div', {
    staticClass: "home-hero__inner group group--first group--last"
  }, [_c('div', {
    staticClass: "home-hero__content"
  }, [_c('h1', {
    staticClass: "home-hero__heading h1 mt0 fw-semibold",
    domProps: {
      "innerHTML": _vm._s(_vm.hero.heading)
    }
  }), _vm._v(" "), _vm._l((_vm.hero.content), function(copy, index) {
    return _c('p', {
      key: index,
      staticClass: "home-hero__copy p",
      domProps: {
        "innerHTML": _vm._s(copy)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "home-hero__get-started"
  }, [_c('div', {
    staticClass: "home-hero__form"
  }, [_c('h4', {
    staticClass: "h4 mt0"
  }, [_vm._v("Are you a Dentist or Endodontist and want to help?")]), _vm._v(" "), _c('module-form', {
    attrs: {
      "form-id": "register-dentist",
      "fields": {
        dentistEmail: {
          type: "email",
          label: "Email",
          labelHidden: true,
          placeholder: "Enter Your Email",
        },
      },
      "button": "primary",
      "button-size": "m",
      "submit": "Sign up now",
      "action": _vm.action,
      "success": _vm.success,
      "fail": _vm.fail
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6afe0228"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoReviewers/Hero.vue
// module id = 280
// module chunks = 0